import {Component, Input, OnInit, Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../../../../../../environments/environment';
import {ContentLocation} from '../../translator/translatorUtils';
import {NgClass} from '@angular/common';
import {ReadReceiptComponent} from '../read-receipt/read-receipt.component';

@Pipe({name: 'getMapsImage'})
export class getMapsImagePipe implements PipeTransform {

    transform(content: any): any {
        return (
            'https://maps.googleapis.com/maps/api/staticmap?center=' +
            content.locationAddress +
            '&zoom=10&size=228x157&maptype=roadmap' +
            '&markers=color:red%7C' +
            content.latitude +
            ',' +
            content.longitude +
            '&key=' +
            environment['googleApiKey']
        );
    }

}

@Component({
    selector: 'app-location',
    templateUrl: './location-chat-bubble.component.html',
    styleUrls: ['./location-chat-bubble.component.scss'],
    imports: [NgClass, ReadReceiptComponent, getMapsImagePipe]
})
export class LocationComponent implements OnInit {
    @Input() messageSource: Boolean;

    @Input()
    content: ContentLocation;

    constructor() {
    }

    ngOnInit() {
    }

    openMapsView() {
        window.open(
            'https://www.google.com/maps/search/?api=1&query=' +
            this.content.latitude +
            '%2C' +
            this.content.longitude,
            '_blank'
        );
    }
}